import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LayerTypeFilter} from '../../../../configuration/model/LayerTypeFilter';
import { LineDashArrayViewComponent } from '../../line-type-item/line-dash-array-view.component';

@Component({
  selector: 'app-legend-class-view',
  templateUrl: './legend-class-view.component.html',
  styleUrls: ['./legend-class-view.component.scss'],
  imports: [LineDashArrayViewComponent],
})
export class LegendClassViewComponent {
  @Input() layerType?: LayerTypeFilter;
  @Input() editable: boolean;

  @Output() colorsChangedEvent: EventEmitter<string[]> = new EventEmitter();

  constructor() {}

  colorChanged(pickedColor: string) {
    if (this.editable && this.layerType != null) {
      this.colorsChangedEvent.emit(this.layerType.measurementUnits.map(value => value.color));
    }
  }
}
